import React from "react";
import Classes from "./styles/style.module.css";
import CustomDatePicker from "../../assets/components/DatePicker";
import CustomButton from "../../assets/components/CustomButton";
import CustomSelect from "../../assets/components/CustomSelect";
import CustomCheckBox from "../../assets/components/CustomCheckBox";
import { DateObject } from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import Loading from "../../assets/containers/loadingDialog";
import { motion } from "framer-motion";

const animations = {
  initial: { opacity: 0, x: -100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 100 },
};

const RegisterSecondStep = ({
  birthDay,
  setBirthDay,
  cooperation,
  setCooperation,
  gender,
  setGender,
  handleRegister,
  loading,
}) => {
  const convertFromDate = (date, format = birthDay.format) => {
    let object = { date, format };
    setBirthDay({
      gregorian: new DateObject(object)
        .convert(gregorian, gregorian_en)
        .format(),
      ...object,
    });
  };

  return (
    <motion.div
      variants={animations}
      initial={animations.initial}
      animate={animations.animate}
      exit={animations.exit}
      className={Classes.loginContent}
    >
      <h3>اطلاعات تکمیلی</h3>
      <CustomDatePicker
        handleChange={convertFromDate}
        val={birthDay}
        lable={"تاریخ تولد"}
      />
      <CustomSelect
        label={"نوع همکاری"}
        handleChange={(value) => {}}
        value={cooperation}
        options={["پرسنل", "بازنشسته", "پیمانکار"]}
        name={"cooperation"}
        placeHolder={"نوع همکاری"}
        disabled
      />
      <CustomSelect
        label={"جنسیت"}
        handleChange={(value) => {}}
        value={gender}
        options={["زن", "مرد"]}
        name={"gender"}
        placeHolder={"جنسیت"}
        disabled
      />
      <div className={Classes.checkBoxContainer}>
        <div className="mt-3">
          <CustomCheckBox
            val={true}
            handleChange={() => {
              return;
            }}
            disabled={true}
            label={"قوانین و مقررات را میپذیرم"}
          />
        </div>
      </div>
      {loading ? (
        <Loading className={"d-flex justify-content-center mt-4"} size={30} />
      ) : (
        <CustomButton
          text={"ثبت"}
          color={"primary"}
          clickHandler={handleRegister}
          styles={{ marginTop: "20px" }}
        />
      )}
    </motion.div>
  );
};

export default RegisterSecondStep;
